<div class="time-input-container">
  <label *ngIf="label" class="time-label">
    {{ label }} <span *ngIf="required" class="required-star">*</span>
  </label>

  <div class="inputs-row">
    <div class="input-wrapper">
      <input
        type="number"
        min="0"
        [(ngModel)]="hours"
        (input)="onInputChange()"
        placeholder="0">
      <span class="unit">h</span>
    </div>

    <div class="input-wrapper">
      <input
        type="number"
        min="0"
        max="59"
        [(ngModel)]="minutes"
        (input)="onInputChange()"
        placeholder="0">
      <span class="unit">min</span>
    </div>
  </div>
</div>
